module.exports = __webpack_public_path__ + "static/media/unesco.1fbce3cd.png";